'use client';

import { updateCartQuantity } from '@/lib/redux/features/cart';
import { useAppDispatch } from '@/lib/redux/hooks';
import { useState } from 'react';

interface CartQuantityProps {
  productId: string;
  currentQuantity: number;
  size?: string;
  className?: string;
}

const CartQuantity: React.FC<CartQuantityProps> = ({
  productId,
  currentQuantity,
  size = '',
  className,
}) => {
  const dispatch = useAppDispatch();

  const handleDecrease = () => {
    if (currentQuantity > 1) {
      const newQty = currentQuantity - 1;
      dispatch(updateCartQuantity({ id: productId, quantity: newQty }));
    }
  };

  const handleIncrease = () => {
    const newQty = currentQuantity + 1;
    dispatch(updateCartQuantity({ id: productId, quantity: newQty }));
  };

  return (
    <div className={`quantity-button ${className}`}>
      <button
        className={`quantity-button__control quantity-button__control--decrease ${size}`}
        onClick={handleDecrease}
      >
        -
      </button>
      <span className={`quantity-button__display ${size}`}>
        {currentQuantity}
      </span>
      <button
        className={`quantity-button__control quantity-button__control--increase ${size}`}
        onClick={handleIncrease}
      >
        +
      </button>
    </div>
  );
};

export default CartQuantity;
